import { Component, OnInit } from "@angular/core";
import { ComponentInterface } from "../../models/component.interface";
import { ComponentConfig } from "../../models/component-config.interface";
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";
import { DashboardService } from "../../../../../services/dashboard.service";
import { AuthService } from "../../../../../services/auth.service";
import { UserModel } from "../../../../../models/user/user.model";
import dictionary from "../../../../../utils/dictionary.json";
import { MdSnackBar } from "@angular/material";
import { LeftMenuService } from "../../../../layout/left-menu.service";
import { Subscription } from "rxjs/Subscription";
import { SharedService } from "../../../../../services/shared.service";

@Component({
  selector: "app-iframe",
  templateUrl: "./iframe.component.html",
  styleUrls: ["./iframe.component.css"],
})
export class IFrameComponent implements ComponentInterface, OnInit {
  config: ComponentConfig;

  urlSafe: SafeResourceUrl;
  title: string = "";
  subtitle: string;
  isLoading: boolean;
  missingData: boolean = false;

  uvZonaSubscription: Subscription;

  private _user: UserModel;

  constructor(
    public sanitizer: DomSanitizer,
    private _dashboardService: DashboardService,
    private authService: AuthService,
    private _sharedService: SharedService,
    private leftMenuService: LeftMenuService,
    private snackBar: MdSnackBar
  ) {
    this._user = authService.user;
  }

  ngOnInit() {
    this.uvZonaSubscription = this._sharedService.uvZona.subscribe((res) => {
      this.load();
    });
    this.load();
  }

  ngOnDestroy() {
    if (this.uvZonaSubscription) {
      this.uvZonaSubscription.unsubscribe();
    }
  }

  private load() {
    this.isLoading = true;
    this._dashboardService
      .getBloccoSlider(this.config.token)
      .subscribe((blocco) => {
        this.title = blocco.titolo;
        this.subtitle = blocco.sottotitolo;
        let queryString = blocco.blocchiIFRAMEUserDefined
          .map((item) => {
            const el = dictionary.find(
              (element) => element.name === item.valore
            );
            let valore = item.valore;
            if (el) {
              valore = this._user[el.value];
              if (el.value.startsWith("@")) {
                valore = this.getDateParmas(el.value).toString();
              }
              if (!valore) {
                this.missingData = true;
                this.showError(
                  "Per poter utilizzare questa funzionalità, è necessario scegliere l'unità di vendita/zona interessata attraverso la voce di menù 'Cambia Uv Zona (per ROLWEB)'"
                );
                return;
              } else {
                this.missingData = false;
              }
            }
            return `${item.nome}=${valore}`;
          })
          .join("&");
        const urlSafe = `${blocco.iFrameSrc}?${queryString}`;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(urlSafe);
        // this._dashboardService
        //   .getIframeData(blocco.iFrameSrc)
        //   .subscribe((res) => console.log(res));
        this.isLoading = false;
      });
  }

  private getDateParmas(value: string) {
    switch (value) {
      case "@anno@":
        return new Date().getFullYear();
      case "@mese@":
        return new Date().getMonth() + 1;
      case "@giorno@":
        return new Date().getDate();
      default:
        console.log(value);
        return undefined;
    }
  }

  private cambiaZonaUV() {
    this.leftMenuService.cambiaUVZONA();
  }

  private showError(message: string) {
    this.snackBar.open("Errore: " + message, "Chiudi", { duration: 5000 });
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/iFrame/iframe.component.ts